import { render, staticRenderFns } from "./rateImport.vue?vue&type=template&id=566b3071&scoped=true&"
import script from "./rateImport.vue?vue&type=script&lang=js&"
export * from "./rateImport.vue?vue&type=script&lang=js&"
import style0 from "./rateImport.vue?vue&type=style&index=0&id=566b3071&lang=scss&scoped=true&"
import style1 from "./rateImport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b3071",
  null
  
)

export default component.exports